import {ValueObject} from '@s-ui/domain'

export class MarketedMakesValueObject extends ValueObject {
  /**
   * @param {Array} makesList
   * */
}
